
define('text!modules/campaign/pixelSegment/templates/bin_item.html',[],function () { return '<div class="column name">\n    <div class="item-c text active" data-action="{{action}}" title="{{{title}}}" >{{{full_path}}}<span class="strong">{{{full_path_end}}}</span></div>\n</div>\n<div class="column recency">\n    <span class="item-c"><!--DDL Goes Here--></span>\n</div>';});

